/* GeckoMagic — interacciones propias (prefijo gm-). Sin librerías. */
(function () {
  if (window.__gmCargado) return;
  window.__gmCargado = true;

  var reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var observador = null;

  function observar(el) {
    if (reducido || !('IntersectionObserver' in window)) {
      el.classList.add('gm-visible', 'gm-split-on');
      if (el.__gmAlEntrar) el.__gmAlEntrar();
      return;
    }
    if (!observador) {
      observador = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) {
          if (!e.isIntersecting) return;
          e.target.classList.add('gm-visible', 'gm-split-on');
          if (e.target.__gmAlEntrar) e.target.__gmAlEntrar();
          observador.unobserve(e.target);
        });
      }, { threshold: 0.18, rootMargin: '0px 0px -6% 0px' });
    }
    observador.observe(el);
  }

  /* Titulares que entran palabra a palabra */
  function initSplit(raiz) {
    raiz.querySelectorAll('[data-gm-split]:not([data-gm-hecho])').forEach(function (el) {
      el.setAttribute('data-gm-hecho', '');
      var i = 0;
      (function recorrer(nodo) {
        Array.prototype.slice.call(nodo.childNodes).forEach(function (hijo) {
          if (hijo.nodeType === 3) {
            var trozos = hijo.textContent.split(/(\s+)/);
            var frag = document.createDocumentFragment();
            trozos.forEach(function (t) {
              if (!t) return;
              if (/^\s+$/.test(t)) { frag.appendChild(document.createTextNode(t)); return; }
              var w = document.createElement('span');
              w.className = 'gm-word';
              var s = document.createElement('span');
              s.style.setProperty('--gm-w', i++);
              s.textContent = t;
              w.appendChild(s);
              frag.appendChild(w);
            });
            hijo.parentNode.replaceChild(frag, hijo);
          } else if (hijo.nodeType === 1 && hijo.tagName !== 'BR') {
            recorrer(hijo);
          }
        });
      })(el);
      observar(el);
    });
  }

  function initReveal(raiz) {
    raiz.querySelectorAll('[data-gm-reveal]').forEach(observar);
  }

  /* Cifras que cuentan */
  function initContadores(raiz) {
    raiz.querySelectorAll('[data-gm-count]').forEach(function (el) {
      var fin = parseFloat(el.getAttribute('data-gm-count'));
      if (isNaN(fin)) return;
      var decimales = (String(fin).split('.')[1] || '').length;
      el.textContent = reducido ? fin.toFixed(decimales) : (0).toFixed(decimales);
      el.__gmAlEntrar = function () {
        if (reducido) return;
        var t0 = null, dur = 1800;
        function paso(t) {
          if (!t0) t0 = t;
          var p = Math.min((t - t0) / dur, 1);
          var e = 1 - Math.pow(1 - p, 4);
          el.textContent = (fin * e).toFixed(decimales);
          if (p < 1) requestAnimationFrame(paso);
        }
        requestAnimationFrame(paso);
      };
      observar(el);
    });
  }

  /* Hero: foco de luz que sigue al cursor + parallax suave */
  function initHero(raiz) {
    raiz.querySelectorAll('.gm-hero').forEach(function (hero) {
      if (hero.__gm) return;
      hero.__gm = true;
      var media = hero.querySelector('.gm-hero__media');
      var intensidad = parseFloat(hero.getAttribute('data-parallax') || '0.15');
      if (!reducido) {
        hero.addEventListener('pointermove', function (ev) {
          var r = hero.getBoundingClientRect();
          hero.style.setProperty('--mx', ((ev.clientX - r.left) / r.width * 100) + '%');
          hero.style.setProperty('--my', ((ev.clientY - r.top) / r.height * 100) + '%');
        });
        if (media && intensidad > 0) {
          var pendiente = false;
          window.addEventListener('scroll', function () {
            if (pendiente) return;
            pendiente = true;
            requestAnimationFrame(function () {
              var r = hero.getBoundingClientRect();
              if (r.bottom > 0 && r.top < window.innerHeight) {
                media.style.transform = 'translate3d(0,' + (-r.top * intensidad) + 'px,0)';
              }
              pendiente = false;
            });
          }, { passive: true });
        }
      }
    });
  }

  /* Tarjetas que se inclinan hacia el cursor */
  function initTilt(raiz) {
    if (reducido || window.matchMedia('(hover: none)').matches) return;
    raiz.querySelectorAll('[data-gm-tilt]').forEach(function (t) {
      if (t.__gm) return;
      t.__gm = true;
      var fuerza = parseFloat(t.getAttribute('data-gm-tilt') || '6');
      t.addEventListener('pointermove', function (ev) {
        var r = t.getBoundingClientRect();
        var x = (ev.clientX - r.left) / r.width;
        var y = (ev.clientY - r.top) / r.height;
        t.style.setProperty('--mx', x * 100 + '%');
        t.style.setProperty('--my', y * 100 + '%');
        t.style.setProperty('--ry', ((x - 0.5) * fuerza) + 'deg');
        t.style.setProperty('--rx', ((0.5 - y) * fuerza) + 'deg');
      });
      t.addEventListener('pointerleave', function () {
        t.style.setProperty('--rx', '0deg');
        t.style.setProperty('--ry', '0deg');
      });
    });
  }

  /* Línea que une los pasos: se alinea con el borde inferior de las fotos */
  function initPasos(raiz) {
    raiz.querySelectorAll('.gm-pasos__fila').forEach(function (fila) {
      var foto = fila.querySelector('.gm-paso__foto');
      if (!foto) return;
      function ajustar() { fila.style.setProperty('--gm-linea-top', foto.offsetHeight + 'px'); }
      ajustar();
      window.addEventListener('resize', ajustar);
      if (foto.querySelector('img')) foto.querySelector('img').addEventListener('load', ajustar);
      observar(fila);
    });
  }

  /* Paneles "ideal para" */
  function initPaneles(raiz) {
    raiz.querySelectorAll('.gm-paneles').forEach(function (cont) {
      var paneles = cont.querySelectorAll('.gm-panel');
      function activar(p) { paneles.forEach(function (x) { x.classList.toggle('gm-activo', x === p); }); }
      paneles.forEach(function (p) {
        p.addEventListener('mouseenter', function () { activar(p); });
        p.addEventListener('focus', function () { activar(p); });
        p.addEventListener('click', function () { activar(p); });
      });
    });
  }

  /* Comparador luz encendida / apagada */
  function initComparador(raiz) {
    raiz.querySelectorAll('.gm-comparador').forEach(function (c) {
      var input = c.querySelector('input[type="range"]');
      if (!input) return;
      function fijar(v) { c.style.setProperty('--pos', v + '%'); }
      input.addEventListener('input', function () { c.classList.remove('gm-pista'); fijar(input.value); });
      fijar(input.value);
      c.__gmAlEntrar = function () {
        if (reducido) return;
        var inicial = input.value;
        c.classList.add('gm-pista');
        fijar(82);
        setTimeout(function () { fijar(18); }, 1100);
        setTimeout(function () { fijar(inicial); }, 2300);
        setTimeout(function () { c.classList.remove('gm-pista'); }, 3600);
      };
      observar(c);
    });
  }

  /* Página de producto: galería, variantes, cantidad, barra fija */
  function initProducto(raiz) {
    raiz.querySelectorAll('[data-gm-producto]').forEach(function (prod) {
      if (prod.__gm) return;
      prod.__gm = true;

      var principal = prod.querySelector('.gm-galeria__principal img');
      var minis = prod.querySelectorAll('.gm-galeria__mini');
      function mostrar(boton) {
        if (!principal || !boton) return;
        minis.forEach(function (m) { m.classList.toggle('gm-activo', m === boton); });
        principal.classList.add('gm-cambiando');
        setTimeout(function () {
          principal.src = boton.getAttribute('data-src');
          principal.srcset = boton.getAttribute('data-srcset') || '';
          principal.alt = boton.getAttribute('data-alt') || '';
          principal.classList.remove('gm-cambiando');
        }, 220);
      }
      minis.forEach(function (m) { m.addEventListener('click', function () { mostrar(m); }); });

      var cant = prod.querySelector('.gm-cantidad input');
      prod.querySelectorAll('.gm-cantidad button').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(cant.value, 10) || 1;
          cant.value = Math.max(1, v + parseInt(b.getAttribute('data-paso'), 10));
        });
      });

      var datos = prod.querySelector('[data-gm-variantes]');
      if (datos) {
        var variantes = JSON.parse(datos.textContent);
        var idInput = prod.querySelector('input[name="id"]');
        var precio = prod.querySelector('[data-gm-precio]');
        var tachado = prod.querySelector('[data-gm-tachado]');
        var botones = prod.querySelectorAll('[data-gm-comprar]');
        var textoAgotado = prod.getAttribute('data-texto-agotado');
        var textoComprar = prod.getAttribute('data-texto-comprar');
        var formato = prod.getAttribute('data-formato-dinero') || '{{amount}}';
        // Respeta todos los formatos de moneda de Shopify (USD 1,234.56 · CLP 39.990 · etc.)
        function agrupar(valor, decimales, miles, coma) {
          var partes = (valor / 100).toFixed(decimales).split('.');
          var entero = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, miles);
          return partes[1] ? entero + coma + partes[1] : entero;
        }
        function dinero(c) {
          return formato.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, tipo) {
            switch (tipo) {
              case 'amount_no_decimals': return agrupar(c, 0, ',', '.');
              case 'amount_with_comma_separator': return agrupar(c, 2, '.', ',');
              case 'amount_no_decimals_with_comma_separator': return agrupar(c, 0, '.', ',');
              case 'amount_with_apostrophe_separator': return agrupar(c, 2, "'", '.');
              case 'amount_no_decimals_with_space_separator': return agrupar(c, 0, ' ', ',');
              case 'amount_with_space_separator': return agrupar(c, 2, ' ', ',');
              default: return agrupar(c, 2, ',', '.');
            }
          });
        }
        prod.querySelectorAll('.gm-compra__opcion input').forEach(function (inp) {
          inp.addEventListener('change', function () {
            var elegidas = [];
            prod.querySelectorAll('.gm-compra__opcion').forEach(function (fs) {
              var marcado = fs.querySelector('input:checked');
              elegidas.push(marcado ? marcado.value : null);
            });
            var v = variantes.find(function (x) {
              return x.options.every(function (o, i) { return o === elegidas[i]; });
            });
            botones.forEach(function (b) {
              b.disabled = !v || !v.available;
              var t = b.querySelector('[data-gm-texto]');
              if (t) t.textContent = v && v.available ? textoComprar : textoAgotado;
            });
            if (!v) return;
            idInput.value = v.id;
            if (precio) precio.textContent = dinero(v.price);
            if (tachado) {
              tachado.textContent = v.compare_at_price > v.price ? dinero(v.compare_at_price) : '';
            }
            if (v.featured_media) {
              var mini = prod.querySelector('.gm-galeria__mini[data-media-id="' + v.featured_media.id + '"]');
              if (mini) mostrar(mini);
            }
            var url = new URL(window.location.href);
            url.searchParams.set('variant', v.id);
            window.history.replaceState({}, '', url.toString());
          });
        });
      }

      var barra = document.querySelector('.gm-barra-fija');
      var boton = prod.querySelector('.gm-compra__fila');
      if (barra && boton && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (e) {
          barra.classList.toggle('gm-visible', !e[0].isIntersecting && e[0].boundingClientRect.top < 0);
        }).observe(boton);
      }
    });
  }

  /* Campañas reales con fecha fija (calendario del tema): la vigente es la misma para todos */
  var campanas = null;
  function campanaVigente() {
    if (!campanas) {
      try { campanas = JSON.parse((document.getElementById('gm-campanas') || {}).textContent || '[]'); } catch (e) { campanas = []; }
      campanas.forEach(function (c) { c.ti = new Date(c.i).getTime(); c.tf = new Date(c.f).getTime(); });
    }
    var ahora = Date.now();
    for (var i = 0; i < campanas.length; i++) {
      if (ahora >= campanas[i].ti && ahora <= campanas[i].tf) return campanas[i];
    }
    return null;
  }

  function pintarNombres() {
    var c = campanaVigente();
    document.querySelectorAll('[data-gm-campana-nombre]').forEach(function (el) {
      el.textContent = c ? c.n : el.getAttribute('data-gm-campana-nombre');
    });
  }

  /* Cuenta regresiva hasta el fin de la campaña vigente (o de una fecha fija) */
  function initCuenta(raiz) {
    pintarNombres();
    raiz.querySelectorAll('[data-gm-cuenta]').forEach(function (c) {
      if (c.__gm) return;
      c.__gm = true;
      var modo = c.getAttribute('data-gm-cuenta');
      var d = c.querySelector('[data-d]'), h = c.querySelector('[data-h]'), m = c.querySelector('[data-m]'), s = c.querySelector('[data-s]');
      function dos(n) { return (n < 10 ? '0' : '') + n; }
      function fin() {
        if (modo !== 'campana') return new Date(modo).getTime();
        var v = campanaVigente();
        return v ? v.tf : NaN;
      }
      function tic() {
        var r = Math.floor((fin() - Date.now()) / 1000);
        if (isNaN(r) || r < 0) { c.hidden = true; pintarNombres(); return; }
        if (r === 0) pintarNombres();
        c.hidden = false;
        d.textContent = dos(Math.floor(r / 86400));
        h.textContent = dos(Math.floor(r % 86400 / 3600));
        m.textContent = dos(Math.floor(r % 3600 / 60));
        s.textContent = dos(r % 60);
      }
      setInterval(function () { tic(); if (modo === 'campana') pintarNombres(); }, 1000);
      tic();
    });
  }

  /* Reseñas propias: "ver más" y botón que abre el formulario de Loox */
  function initResenas(raiz) {
    raiz.querySelectorAll('[data-gm-resenas]').forEach(function (sec) {
      if (sec.__gm) return;
      sec.__gm = true;
      var por = parseInt(sec.getAttribute('data-por-pagina'), 10) || 8;
      var items = sec.querySelectorAll('[data-gm-resena]');
      var mas = sec.querySelector('[data-gm-mas]');
      var visibles = 0;
      function mostrar() {
        visibles += por;
        items.forEach(function (it, i) { it.hidden = i >= visibles; });
        if (mas) mas.hidden = visibles >= items.length;
      }
      if (mas) mas.addEventListener('click', mostrar);
      mostrar();

      // El widget de Loox queda oculto y solo se usa para escribir reseñas
      var loox = document.getElementById('looxReviews');
      var secLoox = loox && loox.closest('.shopify-section');
      if (secLoox) secLoox.classList.add('gm-loox-oculto');
      var escribir = sec.querySelector('[data-gm-escribir]');
      if (escribir) {
        if (!secLoox) { escribir.hidden = true; return; }
        escribir.addEventListener('click', function () {
          secLoox.classList.toggle('gm-loox-oculto');
          if (!secLoox.classList.contains('gm-loox-oculto')) secLoox.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      }
    });
  }

  function init(raiz) {
    raiz = raiz || document;
    initResenas(raiz);
    initCuenta(raiz);
    initSplit(raiz);
    initReveal(raiz);
    initContadores(raiz);
    initHero(raiz);
    initTilt(raiz);
    initPasos(raiz);
    initPaneles(raiz);
    initComparador(raiz);
    initProducto(raiz);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
